import { ReactNode } from "react";
import { InputChkIcon } from "./Icons";

type CheckboxProps = {
  checked: boolean;
  onChange: (val: boolean) => void;
  label?: ReactNode;
  disabled?: boolean;
  className?: string;
  mode?: string;
  useIcon?: boolean;
};

export default function Checkbox({
  checked,
  onChange,
  label,
  className,
  mode,
  disabled,
  useIcon,
}: CheckboxProps) {
  return (
    <label className={"form-input-chk-wrap " + className + (mode ? " mode-" + mode : "")}>
      <input
        disabled={disabled}
        className={"form-input-chk" + (useIcon ? " mode-icon" : "")}
        type="checkbox"
        checked={checked}
        onChange={(e) => {
          onChange(e.target.checked);
        }}
      />
      {useIcon && <InputChkIcon size={28} className="form-input-chk-icon" />}
      <span className="form-input-chk-label">{label}</span>
    </label>
  );
}
